














































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {Promocao} from '@/model/resource/Promocao'
import {PromocaoCollection} from '@/model/collection/PromocaoCollection'
import {ListPromocaoSchema} from '@/schema/resource/Promocao/ListPromocaoSchema'
import {CsvPromocaoSchema} from '@/schema/resource/Promocao/CsvPromocaoSchema'

@Component
export default class ListPromocaoView extends Mixins(MixinQueryRouter) {
  schema = new ListPromocaoSchema()
  collection = new PromocaoCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: Promocao) {
    Helper.pushByName('editPromocao', item.$id)
  }

  async removeItem(item: Promocao) {
    await new DialogRemove(item).confirm(() => item.removePromocao())
    await this.collection.listPromocao()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new PromocaoCollection().clearFilters().addFilter(params)

    await csv.listCsvPromocao()
    new CsvPromocaoSchema().downloadCsv(csv.all())
  }
}
